<template>
   <div id="layout-wrapper">
      <NavBar />
      <SideBar :is-condensed="isMenuCondensed" />
      <div class="main-content">
         <div class="page-content">
            <div class="container-fluid">
               <slot />
            </div>
         </div>
         <Footer />
      </div>
   </div>
</template>

<script>
   import router from "@/router"
   import NavBar from "@/components/layouts/nav-bar"
   import SideBar from "@/components/layouts/side-bar"
   import Footer from "@/components/layouts/footer"

   export default {
      data () {
         return {
            isMenuCondensed: false
         }
      },
      methods: {
         toggleMenu() {
            document.body.classList.toggle("sidebar-enable")

            if (window.screen.width >= 992) {
               // eslint-disable-next-line no-unused-vars
               router.afterEach((routeTo, routeFrom) => {
                  document.body.classList.remove("sidebar-enable")
                  document.body.classList.remove("vertical-collpsed")
               })
               document.body.classList.toggle("vertical-collpsed")
            } else {
               // eslint-disable-next-line no-unused-vars
               router.afterEach((routeTo, routeFrom) => {
                  document.body.classList.remove("sidebar-enable")
               })
               document.body.classList.toggle("vertical-collpsed")
               //document.body.classList.remove("vertical-collpsed")
            }
            this.isMenuCondensed = !this.isMenuCondensed;
         },
         toggleRightSidebar() {
            document.body.classList.toggle("right-bar-enabled")
         },
         hideRightSidebar() {
            document.body.classList.remove("right-bar-enabled")
         }
      },
      components: {
         NavBar, SideBar, Footer
      }
   }
</script>